import React from 'react';

export const CompanyIcon = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3C6 1.34277 7.34375 0 9 0H13C14.6562 0 16 1.34277 16 3V4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H3C1.34315 22 0 20.6569 0 19V7C0 5.34315 1.34315 4 3 4H6V3ZM8 4H14V3C14 2.44727 13.5527 2 13 2H9C8.68945 2 8.41016 2.1416 8.22656 2.36426C8.08594 2.53711 8 2.75879 8 3V4ZM6 12V13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13V12H2V19C2 19.5523 2.44772 20 3 20H19C19.5523 20 20 19.5523 20 19V12H18V13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13V12H6ZM2 7C2 6.44772 2.44772 6 3 6H19C19.5523 6 20 6.44772 20 7V10H2V7Z"
            fill="inherit"
        />
    </svg>
);
